import { UrlObject } from 'url'
import { BlockComponent } from 'lib'
import { AnchorWrapper } from 'experiences/dashboard/DashboardRoot/cards/components/Layout/styles'
import { StyledA } from 'components/elements/links/Anchor'

interface Props {
	href: UrlObject | string
	cta: string
}

export const CardLink: BlockComponent<Props> = ({ href, cta }) => (
	<AnchorWrapper>
		<StyledA href={href}>{cta}</StyledA>
	</AnchorWrapper>
)
